import { render, staticRenderFns } from "./ViewUserSidebar.vue?vue&type=template&id=52158f48&scoped=true&"
import script from "./ViewUserSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewUserSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserSidebar.vue?vue&type=style&index=0&id=52158f48&prod&lang=scss&scoped=true&"
import style1 from "./ViewUserSidebar.vue?vue&type=style&index=1&id=52158f48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52158f48",
  null
  
)

export default component.exports